import { defineComponent as _defineComponent } from 'vue'
import { DatePicker } from 'ant-design-vue'
import { ref, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'YearRangePicker',
  props: {
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value?: string[]
};

const RangePicker = DatePicker.RangePicker



const time = ref()
const isOpen = ref(false)

watch(time, (val) => {
  if (Array.isArray(val) && val.length && val[0].format) {
    emit(
      'input',
      val.map((i) => i.format('YYYY'))
    )
  }
})

function handleOpenChange(status: boolean) {
  isOpen.value = status
}

function handlePanelChange(v: string) {
  time.value = v
  isOpen.value = false
}

function handleChange(v: string) {
  time.value = v
}

return { __sfc: true,RangePicker, props, emit, time, isOpen, handleOpenChange, handlePanelChange, handleChange }
}

})